// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__35YMh","Label":"Input_Label__1J3ck","InputElement":"Input_InputElement__3_9J4","Invalid":"Input_Invalid__3Dprh"};